import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

function Privacy() {
  return (
    <>
      <div className="page-content header-clear-medium">
        <Header />
        <div className="content mt-2">
          <div className="card card-style mx-0 mb-3">
            <Link
              className="content mb-0"
              style={{ margin: "10px 10px 10px 10px" }}
            >
             
              <p className="mb-4">
                At <strong>AG Home Decor</strong>, we are committed to
                protecting your privacy. This policy outlines how we collect,
                use, and safeguard your information.
              </p>

              <h2 className="text-xl font-semibold mt-6 mb-2">
                Information We Collect
              </h2>
              <ul className="list-disc list-inside mb-4">
                <li>
                  Personal Information: Name, Email, Address, Phone Number
                </li>
                <li>Browsing Data: Pages visited, time spent, preferences</li>
              </ul>

              <h2 className="text-xl font-semibold mt-6 mb-2">
                How We Use Your Information
              </h2>
              <ul className="list-disc list-inside mb-4">
                <li>To process and deliver orders</li>
                <li>To improve our website and services</li>
                <li>To send promotional emails (with opt-out option)</li>
              </ul>

              <h2 className="text-xl font-semibold mt-6 mb-2">Data Security</h2>
              <p className="mb-4">
                We use industry-standard measures to protect your data,
                including encryption and secure servers.
              </p>

              <h2 className="text-xl font-semibold mt-6 mb-2">Your Rights</h2>
              <p className="mb-4">
                You can access, update, or delete your personal information at
                any time by contacting us.
              </p>

              <hr className="my-8" />

              <h1 className="text-3xl font-bold mb-6">Terms & Conditions</h1>

              <h2 className="text-xl font-semibold mt-6 mb-2">Introduction</h2>
              <p className="mb-4">
                These terms govern your use of the AG Home Decor website and
                services. By using our platform, you agree to these terms.
              </p>

              <h2 className="text-xl font-semibold mt-6 mb-2">
                Usage Restrictions
              </h2>
              <ul className="list-disc list-inside mb-4">
                <li>You may not use our website for any unlawful purpose.</li>
                <li>
                  You may not attempt to access secure areas without
                  authorization.
                </li>
                <li>
                  All content is the property of AG Home Decor and cannot be
                  reused without permission.
                </li>
              </ul>

              <h2 className="text-xl font-semibold mt-6 mb-2">Liability</h2>
              <p className="mb-4">
                AG Home Decor is not responsible for any damages caused by
                misuse of the website or services.
              </p>

              <h2 className="text-xl font-semibold mt-6 mb-2">
                Changes to Policy
              </h2>
              <p className="mb-4">
                We reserve the right to update these terms and our privacy
                policy at any time. Changes will be posted on this page.
              </p>

             
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Privacy;
